module.exports = __webpack_public_path__ + "img/sell-coins.3ac3e66e.png";